<template>
  <div>
    <div class="login-change-tabs" v-if="businessType === 'login'">
      <div
        class="tab-item"
        :class="[tabActive === item.name ? 'tab-item-active' : '']"
        v-for="item in tabArr"
        :key="item.name"
        @click="tabChange(item.name)"
      >
        <div class="tab-text">{{ item.text }}</div>
        <div class="tab-bar"></div>
      </div>
    </div>
    <div v-else class="forget-pwd-title">输入手机号，获取新密码</div>

    <el-form ref="form" :rules="rules" :model="loginForm" size="mini" label-width="0">
      <el-form-item label="" prop="username">
        <el-input
          v-model.trim="loginForm.username"
          clearable
          placeholder="请输入手机号"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item label="" prop="password" v-if="tabActive === 'password'">
        <el-input
          :type="showPassword ? 'text' : 'password'"
          v-model.trim="loginForm.password"
          auto-complete="off"
          clearable
          placeholder="请输入密码"
          style="width: 100%"
          @keyup.enter.native="handleSubmit"
        >
          <i slot="suffix" @click="switchPassword">
            <img v-if="showPassword" class="input-icon" src="@/static/login/show-pwd.png" />
            <img v-else class="input-icon" src="@/static/login/close-pwd.png" />
          </i>
        </el-input>
      </el-form-item>
      <el-form-item label="" prop="smsCode" v-if="tabActive === 'sms_code'">
        <el-input
          v-model.trim="loginForm.smsCode"
          auto-complete="off"
          placeholder="请输入验证码"
          style="width: 100%"
          @keyup.enter.native="handleSubmit"
        >
          <template slot="suffix">
            <div class="verify-code">
              <div class="split-column"></div>
              <div class="verify-code-tip">
                <el-button
                  type="text"
                  @click="handleVerifyCode"
                  :loading="verifyCodeLoading"
                  :disabled="verifyCodeTime > 0 && verifyCodeTime < 60"
                >
                  {{ verifyCodeTip }}
                </el-button>
              </div>
            </div>
          </template>
        </el-input>
      </el-form-item>
      <VerificationCode
        style="margin-top: 10px"
        v-if="showVerify && tabActive === 'sms_code'"
        :mobilePhone="loginForm.username"
        @emitResult="emitResult"
        :verifyRefresh="verifyRefresh"
      />
    </el-form>

    <div class="btn-area" :style="{ marginTop: tabActive === 'sms_code' ? '70px' : '50px' }">
      <el-button type="success" :loading="loginLoading" @click="handleSubmit">
        {{ businessType === 'login' ? '登录' : '提交' }}
      </el-button>
    </div>
  </div>
</template>

<script >
import store from '@/store';
import { useRouter, useCountDown } from '@/hooks';
import { ref, reactive, inject, computed, nextTick, watch, onBeforeUnmount } from '@vue/composition-api';
import { Message } from 'element-ui';
import { getToken } from '@/util/auth';
import { checkToken } from '@/api/user';
import { sendSmsCode, resetPwdSendSmsCode, resetPasswordBySmsCode, codeVerify } from '@/api/login';
import mqStore from '@/util/mqtt-engine';
import { initMap } from '@/plugins/plugins.amap.js';
import VerificationCode from './verification-code.vue';
import { encode } from 'js-base64';
import { setAesEncrypt } from '@/util/encrypt';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const {
    createConnect
  } = mqStore();
  const router = useRouter();
  const businessType = inject('businessType');

  // 切换密码显示、隐藏
  const showPassword = ref(false);
  const switchPassword = () => {
    showPassword.value = !showPassword.value;
  };
  const form = ref(null);
  const loginForm = ref({
    username: '',
    password: '',
    smsCode: ''
  });
  const rules = reactive({
    username: [{
      required: true,
      message: '请输入手机号',
      trigger: 'blur'
    }, {
      pattern: /^1[0-9]{10}$/,
      message: '请输入正确的手机号码',
      trigger: 'blur'
    }],
    password: [{
      required: true,
      message: '请输入密码',
      trigger: 'blur'
    }],
    smsCode: [{
      required: true,
      message: '请输入验证码',
      trigger: 'blur'
    }, {
      pattern: /^\d{4}$/,
      message: '请输入正确的验证码',
      trigger: 'blur'
    }]
  });
  const tabActive = inject('tabActive');
  const tabArr = [{
    text: '密码登录',
    name: 'password'
  }, {
    text: '验证码登录',
    name: 'sms_code'
  }];
  const tabChange = name => {
    // 切换密码登录隐藏验证滑块
    if (name === 'sms_code') {
      showVerify.value = false;
    }
    tabActive.value = name;
    loginForm.value.password = '';
    loginForm.value.smsCode = '';
    nextTick(() => {
      form.value.clearValidate && form.value.clearValidate();
    });
  };
  watch(businessType, v => {
    if (v === 'forgetPwd') {
      tabChange('sms_code');
    } else {
      tabChange('password');
    }
  });

  // 验证码计时器
  const {
    time: verifyCodeTime,
    start
  } = useCountDown();
  let sT = null; // 定时器
  const verifyCodeTip = computed(() => {
    const str = verifyCodeTime.value === 0 || verifyCodeTime.value === 60 ? '获取验证码' : verifyCodeTime.value + ' s';
    return str;
  });
  const verifyCodeLoading = ref(false);
  // 获取验证码
  const handleVerifyCode = async () => {
    // 校验手机号码
    if (!loginForm.value.username) {
      Message.error('请输入手机号码');
      return;
    }
    if (!/^1[0-9]{10}$/.test(loginForm.value.username)) {
      Message.error('手机号码有误，请检查');
      return;
    }
    if (verifyCodeTime.value > 0 && verifyCodeTime.value < 60 || verifyCodeLoading.value) {
      return;
    }
    verifyCodeLoading.value = true;
    let res = {};
    if (businessType.value === 'forgetPwd') {
      // 重置密码发送验证码
      res = await resetPwdSendSmsCode({
        phone: loginForm.value.username
      });
    } else {
      const result = await codeVerify({
        mobilePhone: loginForm.value.username
      });
      if (result.code) return;
      if (result.data) {
        showVerify.value = result.data;
        verifyRefresh.value = true;
        verifyCodeLoading.value = false;
        Message.info('请先完成校验');
        return;
      } else {
        // 登录发送验证码
        showVerify.value = false;
        res = await sendSmsCode(setAesEncrypt(encode(JSON.stringify({
          mobilePhone: loginForm.value.username
        }))));
      }
    }
    const {
      code
    } = res || {};
    if (code !== 0) {
      verifyCodeLoading.value = false;
      return;
    }
    // 开始倒计时
    start();
    clearST();
    sT = setTimeout(() => {
      verifyCodeLoading.value = false;
    }, 1000);
  };
  const clearST = () => {
    if (sT) {
      clearTimeout(sT);
    }
  };
  onBeforeUnmount(() => {
    clearST();
  });

  // 登录
  const tagWel = computed(() => {
    return store.state.tags.tagWel;
  });
  const loginLoading = ref(false);
  const handleLogin = () => {
    form.value.validate(async valid => {
      if (!valid) {
        return;
      }
      loginLoading.value = true;
      try {
        /**
         * 以下代码应对的场景：
         * 浏览器打开两个窗口都在登录页，一个窗口先登录后，另外一个窗口点击登录，若登录同一个账号，不调用登录接口，直接进入
         */
        const token = getToken();
        if (token) {
          // 判断当前token是否可用
          const res = await checkToken();
          const {
            code,
            data
          } = res || {};
          if (code !== 0) {
            return;
          }
          if (data && data === loginForm.value.username) {
            window.location.reload();
            return;
          }
          await store.dispatch('FedLogOut');
        }
        const param = JSON.parse(JSON.stringify(loginForm.value));
        param.grantType = tabActive.value;
        // 登录
        const res = await store.dispatch('LoginByPhone', param);
        const {
          code
        } = res || {};
        if (code !== 0) {
          return;
        }
        // 获取用户信息
        const res2 = await store.dispatch('GetUserInfo');
        const {
          code: code2
        } = res2 || {};
        if (code2 !== 0) {
          return;
        }
        router.push({
          path: tagWel.value.value
        });

        // 订阅登录登出消息
        createConnect();
        initMap();
        store.dispatch('subScribeLogout', () => {
          router.push({
            path: '/login'
          });
        });
      } catch (error) {
        console.log(error);
      } finally {
        loginLoading.value = false;
      }
    });
  };

  // 重置密码
  const resetPassword = async () => {
    form.value.validate(async valid => {
      if (!valid) {
        return;
      }
      const param = {
        phone: loginForm.value.username,
        smsCode: loginForm.value.smsCode
      };
      loginLoading.value = true;
      const res = await resetPasswordBySmsCode(param);
      loginLoading.value = false;
      const {
        code
      } = res || {};
      if (code !== 0) {
        return;
      }
      Message.success('新密码已通过短信发送，注意查收');
      // 返回登录页
      businessType.value = 'login';
    });
  };
  const handleSubmit = () => {
    if (businessType.value === 'login') {
      handleLogin();
      return;
    }
    resetPassword();
  };
  const verifyRefresh = ref(false);
  const showVerify = ref(false);
  const emitResult = type => {
    if (type) {
      verifyRefresh.value = false;
      // 开始倒计时
      start();
      clearST();
    }
  };
  return {
    businessType,
    showPassword,
    switchPassword,
    form,
    loginForm,
    rules,
    tabActive,
    tabArr,
    tabChange,
    verifyCodeTime,
    verifyCodeTip,
    verifyCodeLoading,
    handleVerifyCode,
    loginLoading,
    handleSubmit,
    verifyRefresh,
    showVerify,
    emitResult
  };
};
__sfc_main.components = Object.assign({
  VerificationCode
}, __sfc_main.components);
export default __sfc_main;
</script>

<style lang="scss" scoped>
  .login-change-tabs {
    margin-bottom: 40px;
    height: 40px;
    display: flex;
    .tab-item {
      position: relative;
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
    }
    .tab-text {
      cursor: pointer;
      font-size: 20px;
      font-weight: 700;
      color: #333;
      letter-spacing: 0.1px;
      &:hover {
        color: #22c655;
      }
    }
    .tab-bar {
      width: 15%;
      height: 5px;
      border-radius: 3px;
      background: none;
    }

    .tab-item-active {
      .tab-text {
        color: #22c655;
      }
      .tab-bar {
        background: #22c655;
      }
    }
  }

  .input-icon {
    cursor: pointer;
    width: 16px;
    height: 12px;
    padding-right: 6px;
  }

  .forget-pwd-title {
    margin-bottom: 55px;
    font-size: 20px;
    font-weight: 700;
    color: #333333;
    letter-spacing: 0.1px;
    text-align: center;
  }

  .verify-code {
    height: 100%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    .split-column {
      width: 1px;
      height: 19px;
      background: #d9d9d9;
    }
    .verify-code-tip {
      width: 118px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    ::v-deep .el-button {
      font-size: 16px;
      font-weight: 500;
      color: #22c655;
    }
    ::v-deep.el-button.is-disabled.el-button--text {
      color: #d9d9d9;
    }
  }

  .btn-area {
    margin-top: 50px;
  }

  ::v-deep .el-form-item--mini.el-form-item {
    margin-bottom: 30px;
  }
  ::v-deep .el-form-item--mini .el-form-item__content {
    line-height: 60px;
  }
  ::v-deep .el-form-item--mini.el-form-item {
    height: 60px;
    line-height: 60px;
  }
  ::v-deep .el-input--mini .el-input__inner {
    height: 60px;
    line-height: 60px;
  }
  ::v-deep .el-input--mini {
    font-size: 16px;
  }
  ::v-deep .el-input__inner {
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    background: #fafafa;
  }
  ::v-deep .el-input__inner:focus {
    background: #ffffff;
    border: 1px solid #22c655;
  }
  ::v-deep .el-button--success {
    width: 100%;
    height: 60px;
    background-color: #22c655;
    border-color: #22c655;
  }
  ::v-deep .el-button {
    font-size: 20px;
    font-weight: 700;
  }
  ::v-deep .el-button--success:focus {
    background-color: #25de5e;
    border-color: #25de5e;
  }
  ::v-deep .el-button--success:hover {
    background-color: #23d25a;
    border-color: #23d25a;
  }
</style>
